import React, {useState} from 'react';
import {RiMenu3Line, RiCloseLine} from "react-icons/ri";
import logo from "../../assets/logo.svg";
import "./navbar.css";
import { useAuth0 } from "@auth0/auth0-react";
import Profile from '../profile/Profile';


const Menu = () => (
    <>
    <p><a href="#home" className="nav-link">Home</a></p>
    <p><a href="#wgpt3" className="nav-link">What is GPT?</a></p>
    <p><a href="#possibility" className="nav-link">Open AI</a></p>
    <p><a href="#features" className="nav-link">Case Studies</a></p>
    <p><a href="#blog" className="nav-link">Library</a></p>
    </>
)

const Navbar = () => {

    const { loginWithRedirect, isAuthenticated, user } = useAuth0();

    const [toggleMenu, setToggleMenu] = useState(false);

    return (
        <div className="gpt3__navbar">
            <div className="gpt3__navbar-links">
                <div className="gpt3__navbar-links_logo">
                    <img src={logo} alt="Logo" />
                </div>

                <div className="gpt3__navbar-links_container">
                    <Menu />
                </div>
            </div>
            
                {isAuthenticated? <Profile /> : 
                <div className="gpt3__navbar-sign">
                <p className="sign-p" onClick={() => loginWithRedirect()}>Sign in</p>
                <button type="button" className="sign-b" onClick={() => loginWithRedirect()}>Sign up</button>
                </div>
                }
           

            <div className="gpt3__navbar-menu">
                {toggleMenu
                    ? <RiCloseLine color="#fff" size={27} onClick={()=>setToggleMenu(false)} />
                    : <RiMenu3Line color="#fff" size={27} onClick={()=>setToggleMenu(true)} />
                }
                {toggleMenu && (
                    <div className="gpt3__navbar-menu_container scale-up-center"> 
                        <div className="gpt3__navbar-menu_container-links" > 
                            <Menu />
                            <div className="gpt3__navbar-menu_container-links-sign">
                                <p>Sign in</p>
                                <button type="button" onClick={() => loginWithRedirect()}>Sign up</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Navbar
